export function isSerialNumberValid(serialNr: string): boolean {
  if (!serialNr) {
    return false;
  }

  return /^[A-Z\d]{12}$/.test(serialNr);
}
